var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "enrol", tag: "section" }
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading } },
        [
          _c("h1", { staticClass: "text-center" }, [
            _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
          ]),
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-card",
            { attrs: { width: "600" } },
            [
              _c("v-card-title", [
                _c("img", {
                  attrs: {
                    id: "mark",
                    src: require("@/assets/Bodyswaps_NO_mark.svg")
                  }
                }),
                _vm._v(_vm._s(_vm.$t("enrol.class-invitation")))
              ]),
              !_vm.error && !_vm.complete
                ? _c(
                    "v-card-text",
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("enrol.been-invited")))]),
                      _c("p", [_vm._v(_vm._s(_vm.$t("enrol.enter-details")))]),
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.greetText) }
                      }),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              readonly: "",
                              label: _vm.$t("enrol.class-id")
                            },
                            model: {
                              value: _vm.className,
                              callback: function($$v) {
                                _vm.className = $$v
                              },
                              expression: "className"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("enrol.your-name"),
                              name: "name",
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.displayName,
                              callback: function($$v) {
                                _vm.displayName = $$v
                              },
                              expression: "displayName"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("enrol.your-email"),
                              name: "email",
                              rules: [_vm.rules.email, _vm.permittedDomain],
                              hint: _vm.domainHint
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _c("v-switch", {
                            attrs: { label: _vm.$t("enrol.remember-me") },
                            model: {
                              value: _vm.remember,
                              callback: function($$v) {
                                _vm.remember = $$v
                              },
                              expression: "remember"
                            }
                          }),
                          !_vm.error
                            ? _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "blue",
                                        disabled: !_vm.validSubmit
                                      },
                                      on: { click: _vm.submit }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("global.submit")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.error
                ? _c("v-card-text", [
                    _vm.error === "emailNotFound"
                      ? _c(
                          "div",
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("enrol.email-address-not-found"))
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("enrol.contact-administrator"))
                              )
                            ]),
                            _c(
                              "v-card-actions",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "blue" },
                                    on: { click: _vm.reload }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("global.back")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm.error === "class_full"
                      ? _c("div", [
                          _c("p", [_vm._v(_vm._s(_vm.$t("enrol.class-full")))]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("enrol.contact-administrator"))
                            )
                          ])
                        ])
                      : _vm.error === "max_users"
                      ? _c("div", [
                          _c("p", [_vm._v(_vm._s(_vm.$t("enrol.max-users")))]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("enrol.contact-administrator"))
                            )
                          ])
                        ])
                      : _vm.error === "class_expired"
                      ? _c("div", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "sorry-this-class-is-nolonger-accepts-new-participants"
                                )
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("enrol.contact-administrator"))
                            )
                          ])
                        ])
                      : _c(
                          "div",
                          [
                            _c("p", [_vm._v(_vm._s(_vm.$t("enrol.bad-link")))]),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("enrol.contact-administrator"))
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("enrol.error")) + " "),
                              _c("b", [_vm._v(_vm._s(_vm.error))])
                            ]),
                            _c(
                              "v-card-actions",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "blue" },
                                    on: { click: _vm.reload }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("global.back")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ])
                : _vm._e(),
              _vm.complete
                ? _c("v-card-text", [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("enrol.has-been-accepted")))
                    ]),
                    _vm.redirectURL
                      ? _c("div", [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("enrol.redirection-warning")))
                          ])
                        ])
                      : _c("div", [
                          _c("p", [_vm._v(_vm._s(_vm.$t("enrol.check-email")))])
                        ])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }